/**
 * @generated SignedSource<<09ceaf4ae8575c100e6cda8161f989bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "webhookService",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "step52WebhookServiceQuery",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "step52WebhookServiceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "af4a0383a3dcb59e661427995d9e06da",
    "id": null,
    "metadata": {},
    "name": "step52WebhookServiceQuery",
    "operationKind": "mutation",
    "text": "mutation step52WebhookServiceQuery(\n  $request: WebhookServiceRequestInput\n) {\n  webhookService(request: $request) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "a409626640d89214538a266ca3263dcb";

module.exports = node;
